import { MutationTree } from 'vuex'
import { Tags } from './types'
import { Tag } from '@/helpers/objects'

export const mutations: MutationTree<Tags> = {
  setTags(state, { tags }) {
    state.tags = []
    tags.forEach(tag => {
      const { id, label, color } = tag
      const newTag = new Tag({ id, label, color })
      state.tags.push(newTag)
    })
    state.filterTags = state.tags
  },
  setPersonGroups(state, { personGroups }) {
    state.personGroups = []
    personGroups.forEach(personGroup => {
      const { id, label, color } = personGroup
      const newPersonGroup = new Tag({ id, label, color })
      state.personGroups.push(newPersonGroup)
    })
    state.filterPersonGroups = state.personGroups
  },
  setCurrentTag(state, { tagData }) {
    const newTag = new Tag({
      id: tagData.id,
      label: tagData.label,
      color: tagData.color
    })
    state.currentTag = newTag
  },
  setCurrentThingsToTag(state, { thingsTagData }) {
    state.currentThingsTagged = thingsTagData
  },
  setCurrentAgentsToTag(state, { agentsTagData }) {
    state.currentAgentsTagged = agentsTagData
  },
  setCurrentPersonsToTag(state, { personsTagData }) {
    state.currentPersonsTagged = personsTagData
  },
  cleanThingsState(state) {
    state.tags.splice(0)
  },
  setResponseError(state, payload) {
    state.responseError = payload
  },
  setResponseMessage(state, message) {
    state.responseMessage = message
  },
  setFilterTagsByString(state, { filterTags }) {
    state.filterTags = filterTags
  },
  resetFilterTagsState(state) {
    state.filterTags = state.tags
  },
  setFilterPersonGroupsByString(state, { filterPersonGroups }) {
    state.filterPersonGroups = filterPersonGroups
  },
  resetFilterPersonGroupsState(state) {
    state.filterPersonGroups = state.personGroups
  }
}
